import { useCreation } from 'ahooks'

import { useHasPermissionFn } from '../useHasPermissionFn'

export const useAuthorizedResource = (
  permission?: string,
  onlyAdministrator?: boolean
) => {
  const hasPermission = useHasPermissionFn()

  return useCreation(
    () => hasPermission(permission, onlyAdministrator),
    [permission, onlyAdministrator, hasPermission]
  )
}
